<template>
  <div class="page">
    <Header :activeIndex="1" />
    <div class="service_box w">
      <!-- breadcrumb -->
      <div class="breadcrumb">
        <img class="icon" src="../assets/images/service/icon.png" />
        <span @click="toHome">Home</span>
        <img class="arrow" src="../assets/images/service/arrow.png" />
        <span @click="toService">SERVICES</span>
        <template v-if="catSelected === 0 || catSelected">
          <img class="arrow" src="../assets/images/service/arrow.png" />
          <span @click="toCategory">{{ catList[catSelected].name }}</span>
        </template>
        <template v-if="showDetail">
          <img class="arrow" src="../assets/images/service/arrow.png" />
          <span style="color: #2090ff">{{ catList[catSelected].name }}</span>
        </template>
      </div>
      <!-- !showDetail -->
      <div v-if="!showDetail">
        <!-- category -->
        <ul class="category flex3">
          <li
            v-for="(item, index) in catList"
            :key="index"
            :class="[catSelected === index ? 'active' : '']"
            @click="selectCat(index)"
          >
            {{ item.name }}
          </li>
        </ul>
        <!-- catList -->
        <ul v-if="catSelected === 0 || catSelected" class="list flex5">
          <li @click="toDetail(catSelected)">
            <img :src="catList[catSelected].img" />
            <div class="name">{{ catList[catSelected].name }}</div>
          </li>
        </ul>
        <ul v-else class="list flex5">
          <li
            @click="toDetail(index)"
            v-for="(item, index) in catList"
            :key="index"
          >
            <img :src="item.img" />
            <div class="name">{{ item.name }}</div>
          </li>
        </ul>
        <!-- paganation -->
        <div class="paganation flex4">
          <div class="btn" @click="toHome">Home</div>
          <div class="btn">Previous</div>
          <div class="btn current">1</div>
          <div class="btn">Next</div>
          <div class="btn">End</div>
        </div>
      </div>
      <!-- showDetail -->
      <div v-else class="detail_box">
        <div class="name">{{ catList[catSelected].name }}</div>
        <img :src="catList[catSelected].img" alt="" />
        <div v-if="catSelected === 0" class="content">
          <p class="name">Wire EDM</p>
          <p>
            low speed wire WEDM is an English abbreviation for WEDM-LS. It uses
            continuously moving thin metal wire (called electrode wire) as
            electrode to remove metal and cut the workpiece by pulse spark
            discharge. It is mainly used to process various complicated and
            precise workpieces, WEDM is usually divided into two categories: one
            is slow wire (also known as low-speed wire WEDM) electrode wire for
            low-speed unidirectional motion, the general wire speed is less than
            0.2m/s, accuracy of 0.001mm class, surface quality is close to the
            grinding level. The electrode wire is no longer used after
            discharge, and it works stably, evenly, with small jitter and good
            processing quality. Moreover, advanced power supply technology is
            adopted to realize high-speed machining, and the maximum
            productivity can reach 350mm2/min.
          </p>

          <p>
            Because the wire electrode is continuously supplied by the slow
            moving wire cutting machine, that is, the wire electrode is
            processed in the process of movement, so even if the wire electrode
            is lost, it can be continuously supplemented, so the machining
            accuracy of parts can be improved. The surface roughness of the
            workpiece machined by the low speed wire cutting machine can reach
            RA = 0.8 μ The roundness error, linear error and dimension error of
            slow wire cutting machine are much better than that of fast wire
            cutting machine, so slow wire cutting machine has been widely used
            in processing high-precision parts. It is easy to operate and
            suitable for small and medium enterprises.
          </p>

          <p>
            Fast wire is a kind of WEDM, also known as WEDM-HS. Its electrode
            wire (usually molybdenum wire) moves back and forth at a high speed
            with a wire speed of 8-10m / s. the electrode wire can be reused and
            the processing speed is high. It is easy to cause electrode wire
            jitter and pause in reverse direction, which leads to the decline of
            processing quality, It is the main machine type produced and used in
            our country, and it is the original WEDM machining mode in our
            country.
          </p>

          <p>EDM</p>

          <p>
            EDM machining is mainly used for machining dies and parts with
            complex shaped holes and cavities; Processing all kinds of
            conductive materials, such as cemented carbide and quenched steel,
            etc; Processing deep and fine holes, special-shaped holes, deep
            grooves, narrow slots and cutting thin slices; Processing all kinds
            of forming tools, templates and thread ring gauge and other tools.
          </p>

          <p>
            EDM machining technology is also called EDM technology. It is a new
            technology which replaces traditional machining cavity with shaped
            electrode. It is a simple tubular electrode with high speed rotation
            for three-dimensional or two-dimensional contour machining (like NC
            milling), so it is no longer necessary to manufacture complex shaped
            electrode,
          </p>

          <p>
            EDM (electrical discharge machining) is a kind of machining
            equipment, which is mainly used in EDM. It is widely used in the
            manufacture of various metal mould and mechanical equipment. It is a
            special processing method which can remove conductive materials by
            the electrical erosion generated by the pulse discharge between the
            two poles immersed in the working liquid, also known as discharge
            processing or electrical etching.
          </p>
        </div>
        <!-- 1 -->
        <div v-if="catSelected === 1" class="content">
          <p>
            It is necessary to select high quality steel and apply corresponding
            surface treatment technology to improve the service life of the die.
            Die heat treatment and surface treatment are also the key links to
            determine the material properties of the final die steel.
          </p>

          <p>
            Surface treatment is to form a layer of special properties on the
            surface of materials by physical or chemical methods. Surface
            treatment can improve the product appearance, texture, function and
            other aspects of performance.
          </p>

          <p>
            The following is a detailed introduction of various surface
            treatment processes for metal 3D printing parts:
          </p>

          <p>1.Anodic oxidation</p>

          <p>
            Anodic oxidation is the electrochemical oxidation of metals or
            alloys. Metal or alloy parts are used as anode, and oxide film is
            formed on the surface by electrolysis. Metal oxide film changes the
            surface state and properties, such as surface coloring, improving
            corrosion resistance, enhancing wear resistance and hardness,
            protecting metal surface, etc. For example, anodization of aluminum,
            aluminum and its alloys are placed in the corresponding electrolyte
            (such as sulfuric acid, chromic acid, oxalic acid, etc.) as anode,
            and electrolysis is carried out under specific conditions and
            applied current. A thin layer of alumina is formed on the surface of
            anodized aluminum or its alloy, with a thickness of 5-20 μ m, and a
            hard anodized film of 60-200 μ M. The hardness and wear resistance
            of anodized aluminum or its alloy are improved, which can reach
            250-500 kg/m2. It has good heat resistance. The melting point of
            hard anodized film is up to 2320k. It has excellent insulation. The
            breakdown voltage is up to 2000V, which enhances the corrosion
            resistance ω＝ 0.03 NaCl salt spray does not corrode after thousands
            of hours. There are a lot of micropores in the thin oxide film,
            which can absorb all kinds of lubricants and is suitable for
            manufacturing engine cylinders or other wear-resistant parts; The
            microporous membrane has strong adsorption capacity and can be
            colored into various beautiful colors.
          </p>

          <p>Advantages of anodizing:</p>

          <p>1). Anti static. 2). Surface magnesium. 3). Wear resistance.</p>

          <p>
            Many small aluminum parts on semiconductor equipment need anodizing
            treatment, in order to increase hardness and reduce wear.
          </p>

          <p>2. Phosphating treatment</p>

          <p>
            Phosphating is a common pretreatment technology. In principle, it
            belongs to chemical conversion coating treatment. It is mainly used
            for phosphating steel surface, and non-ferrous metal parts (such as
            aluminum and zinc) can also be used for phosphating.
          </p>

          <p>
            Phosphating is a process of chemical and electrochemical reaction to
            form phosphate chemical conversion film, which is called phosphating
            film. The main purpose of phosphating is to provide protection for
            the base metal and prevent the metal from being corroded to a
            certain extent; It is used for priming before painting to improve
            the adhesion and anti-corrosion ability of paint film; It plays the
            role of reducing friction and lubrication in metal cold working
            process.
          </p>

          <p>
            Phosphating is a process of chemical and electrochemical reaction to
            form phosphate chemical conversion film, which is called phosphating
            film. The main purpose of phosphating is to provide protection for
            the base metal and prevent the metal from being corroded to a
            certain extent; It is used for priming before painting to improve
            the adhesion and anti-corrosion ability of paint film; It plays the
            role of reducing friction and lubrication in metal cold working
            process.
          </p>

          <p>
            Phosphating is a process of chemical and electrochemical reaction to
            form phosphate chemical conversion film, which is called phosphating
            film. The main purpose of phosphating is to provide protection for
            the base metal and prevent the metal from being corroded to a
            certain extent; It is used for priming before painting to improve
            the adhesion and anti-corrosion ability of paint film; It plays the
            role of reducing friction and lubrication in metal cold working
            process.
          </p>

          <p>
            Phosphating is a process of chemical and electrochemical reaction to
            form phosphate chemical conversion film, which is called phosphating
            film. The main purpose of phosphating is to provide protection for
            the base metal and prevent the metal from being corroded to a
            certain extent; It is used for priming before painting to improve
            the adhesion and anti-corrosion ability of paint film; It plays the
            role of reducing friction and lubrication in metal cold working
            process.
          </p>

          <p>3). Improve the decoration.</p>

          <p>3. Blackening treatment</p>

          <p>
            Blackening is a common method of chemical surface treatment. The
            principle is to produce a layer of oxide film on the metal surface
            to isolate the air and achieve the purpose of rust prevention.
          </p>

          <p>
            There are two common methods of blackening: the traditional alkaline
            heating blackening and the later room temperature blackening.
            However, the effect of room temperature blackening process on low
            carbon steel is not very good. Alkaline blackening is subdivided
            into one blackening and two blackening. The main components of
            blackening liquor are sodium hydroxide and sodium nitrite. When
            blackening, the tolerance of temperature is relatively large, and a
            good surface can be obtained between 135-155 ℃, but the time
            required is only a little long.
          </p>

          <p>4. Passivation treatment</p>

          <p>
            The phenomenon that the corrosion rate of metal treated by oxidizing
            medium is significantly lower than that before treatment is called
            metal passivation. The passivation mechanism can be explained by the
            film theory, that is to say, passivation is due to the interaction
            between metal and oxidizing medium, which forms a very thin, dense,
            well covered passivation film on the metal surface and can be firmly
            attached to the metal surface. The film exists as an independent
            phase, usually a compound of oxygen and metal. It can completely
            separate the metal from the corrosive medium and prevent the metal
            from directly contacting with the corrosive medium, so that the
            metal can basically stop dissolving and form a passive state, so as
            to achieve the effect of preventing corrosion.
          </p>

          <p>
            Passivation treatment is the last process step in chemical cleaning,
            and it is the key step. Its purpose is to protect the material from
            corrosion. Such as the boiler after pickling, water washing,
            rinsing, the metal surface is very clean, very activated, it is easy
            to suffer corrosion, so it must be passivated immediately, so that
            after cleaning the metal surface to form a protective film, slow
            down corrosion.
          </p>

          <p>5. Radium carving</p>

          <p>
            Radium carving, also known as laser carving or laser marking, is a
            surface treatment process based on optical principles. Radium
            carving is a marking method that uses high energy density laser to
            irradiate the workpiece locally, which makes the surface material
            vaporize or change color instantly, thus leaving a permanent mark.
            Radium engraving can produce all kinds of characters, symbols and
            patterns, and the size of characters can range from millimeter to
            micron. This technology can produce characters without any marks.
            The surface of the object is still smooth and the handwriting will
            not be worn.
          </p>

          <p>6. Electrophoretic paint</p>

          <p>
            The electrophoresis process is divided into anode electrophoresis
            and cathode electrophoresis. If the coating particles are negatively
            charged, the workpiece is the anode, and the coating particles
            deposit a film on the workpiece under the action of electric field
            force, which is called anodic electrophoresis; On the contrary, if
            the coating particles are positively charged, the workpiece is the
            cathode, and the coating particles deposit a film on the workpiece,
            which is called cathodic electrophoresis.
          </p>

          <p>Electrophoretic application:</p>

          <p>
            It can be divided into anode electrophoretic paint and cathode
            electrophoretic paint.
          </p>

          <p>
            Among them, the anodic electrophoretic paint has anodic acrylic
            acid, which is mainly used in aluminum products. After aluminum is
            oxidized, it is protected by anodic electrophoretic paint. The gloss
            is between 50-90 degrees and the paint film is thin, so it is widely
            used in aluminum profile industry. Cathodic electrophoretic paint
            can be divided into epoxy electrophoretic paint, acrylic
            electrophoretic paint and polyurethane electrophoretic paint.
          </p>

          <p>7. wire drawing</p>

          <p>
            Wire drawing technology is a kind of metal processing technology. In
            metal pressure processing. Under the action of external force, the
            metal is forced through the die, the cross-sectional area of the
            metal is compressed, and the required cross-sectional area shape and
            size are obtained. Make it change shape. The size of the tool is
            called the drawing die. For example, in the cable industry, the 8mm
            copper rod is pulled into copper wire, such as 3.5mm, 2.0mm, through
            a group of (5 ~ 8) drawing dies from large to small.
          </p>

          <p>
            Wire drawing is a method to improve the surface finish of the
            workpiece by using the reciprocating motion of the drawn cloth and
            rubbing it back and forth on the surface of the workpiece. The
            surface texture is linear. It can improve the surface quality and
            mask the slight scratch on the surface.
          </p>

          <p>Function of wire drawing:</p>

          <p>
            The surface of metal plate has anti rust, anti-oxidation, anti
            scratch, anti chemical agent and anti smoke properties. In terms of
            appearance, due to the special bright surface of the product itself,
            in order to avoid losing luster due to friction, it is recommended
            to apply it to the horizontal surface with less friction or the
            general vertical surface. In addition, it is recommended to use it
            in a dry place, or a place where it will not get wet frequently, and
            where the humidity is not too heavy, so as to maintain the stability
            of the product. Wire drawing on metal surface can well cover up the
            mechanical lines and mold closing defects in production.
          </p>

          <p>8. CD pattern</p>

          <p>
            CD pattern is a kind of effect similar to CD pattern, which is
            obtained by using precise CD pattern machine to remove materials on
            metal surface. The spacing of CD pattern is determined according to
            the appearance and size of the product. In the industry, it is
            generally recognized that CD pattern is a high-grade surface
            treatment process for metal surface.
          </p>

          <p>
            High quality CD pattern processing must have the following five
            elements:
          </p>

          <p>1. High precision CD texturing machine.</p>

          <p>2. Scientific product processing fixture.</p>

          <p>3. Well trained process operators.</p>

          <p>4. Choose reasonable cutting tools.</p>

          <p>5. Correct cooling scheme.</p>
        </div>
        <!-- 2 -->
        <div v-if="catSelected === 2" class="content">
          <p>
            With a full range of services, we are able to combine 3D printing
            prototype manufacturing with traditional CNC processing and small
            batch injection molding to meet the needs of almost every design
            team.
          </p>

          <p>
            Common hybrid manufacturing equipment integrated with metal 3D
            printing technology can be classified into three categories: Metal
            3D printing and milling Hybrid Machining Based on directional energy
            deposition process; Based on powder bed technology, 3D printing and
            milling of selective laser melting were mixed; Ultrasonic 3D
            printing and milling mixed processing.
          </p>

          <p>
            The manufacturing equipment of directional energy deposition 3D
            printing and milling is a hybrid equipment of metal 3D printing
            technology and turn milling compound processing, especially for the
            small batch production of difficult to machine materials, such as
            the processing of aerospace parts heat-resistant alloy, the
            processing of high hardness materials of tools and parts in the
            energy field, and the processing of high-precision special alloy in
            the manufacturing of medical equipment.
          </p>

          <p>
            The equipment belongs to directional energy deposition process,
            which uses fiber laser to heat melt metal powder, metal 3D printing
            nozzle to apply molten material layer by layer, and each molten
            material solidifies with the growth of the required shape. This
            process can be used to repair worn parts, such as aviation turbine
            blades. The original design method of metal parts has been
            completely changed to make the products, components and tools
            lighter, realize more functions and reduce the number of assembly
            parts. Integrated high-precision metal manufacturing solution
            integrates software, direct metal printing technology, certified
            materials and expert application support. It can save time, increase
            efficiency, save cost and manufacture lightweight components.
          </p>

          <p>
            Our 3D printers produce plastic conceptual models, high-precision
            and functional prototypes, master molds, and true end use components
            to optimize your design, simplify workflow, and bring innovative
            products to market faster. Direct metal printing (DMP) is made of
            various alloy materials, which can't be realized by traditional
            reduced material manufacturing technology.
          </p>
        </div>
        <!-- 3 -->
        <div v-if="catSelected === 3" class="content">
          <p>
            CNC machine tools include drilling and tapping machine, parts
            processing center, mold processing center, horizontal processing
            center, carving and milling machine, high gloss machine, glass
            engraving machine, sweeping machine, CNC lathe, Longmen machining
            center and other series of precision processing equipment.
          </p>

          <p>
            CNC machining is suitable for the production of plastic and metal
            parts or the rapid prototyping of the final production materials.
          </p>

          <p>Characteristics of CNC machine tool processing technology</p>

          <p>
            1.High degree of automation, can reduce the manual labor intensity
            of the operator. The CNC machining process is automatically
            completed according to the input program. The operator only needs to
            start the tool setting, loading and unloading the workpiece, and
            changing the tool. In the machining process, the main task is to
            observe and supervise the operation of the machine tool. However,
            due to the high technical content of CNC machine tools, the mental
            work of operators is improved accordingly.
          </p>

          <p>
            2. This project has high precision and stable quality. The
            positioning accuracy and repeated positioning accuracy of CNC
            machine tools are very high, so it is easy to ensure the consistency
            of the size of a batch of parts. As long as the process design and
            program are correct and reasonable, combined with careful operation,
            it can ensure that the parts can obtain higher processing accuracy,
            and it is also convenient for the quality control of the processing
            process.
          </p>

          <p>
            3. High production efficiency. CNC machining can process multiple
            machining surfaces in one clamping, generally only the first
            workpiece is detected, so many intermediate processes, such as
            scribing, dimension detection, etc., can be omitted in ordinary
            machine tool processing, which reduces the auxiliary time. Moreover,
            due to the stable quality of parts processed by CNC, it brings
            convenience for subsequent processes, and its comprehensive
            efficiency is significantly improved.
          </p>

          <p>
            4. It is convenient for the development and modification of new
            products. In general, there is no need for many complex process
            equipment in the CNC machining process, the parts with complex shape
            and high precision can be processed by programming, When the product
            is remodeled and the design is changed, only the program is changed,
            and there is no need to redesign the tooling. Therefore, CNC
            machining can greatly shorten the product development cycle, and
            provide a shortcut for the development, improvement and modification
            of new products.
          </p>

          <p>
            5. It can develop to a more advanced manufacturing system. Numerical
            control machine tool and its processing technology are the basis of
            computer aided manufacturing.
          </p>

          <p>
            6. The initial investment is large. This is due to the high cost of
            CNC machine tools, long preparation period for the first processing
            and high maintenance cost.
          </p>

          <p>
            7. High maintenance requirements. Numerical control machine tool is
            a typical product of mechatronics, which is technology intensive. It
            needs maintenance personnel to understand not only machinery, but
            also microelectronics maintenance knowledge, and better maintenance
            equipment.
          </p>

          <p>CNC turn milling compound 3D printer</p>

          <p>
            With a full range of services, we are able to combine 3D printing
            prototype manufacturing with traditional CNC processing and small
            batch injection molding to meet the needs of almost every design
            team.
          </p>

          <p>
            Common hybrid manufacturing equipment integrated with metal 3D
            printing technology can be classified into three categories: Metal
            3D printing and milling Hybrid Machining Based on directional energy
            deposition process; Based on powder bed technology, 3D printing and
            milling of selective laser melting were mixed; Ultrasonic 3D
            printing and milling mixed processing.
          </p>

          <p>
            The manufacturing equipment of directional energy deposition 3D
            printing and milling is a hybrid equipment of metal 3D printing
            technology and turn milling compound processing, especially for the
            small batch production of difficult to machine materials, such as
            the processing of aerospace parts heat-resistant alloy, the
            processing of high hardness materials of tools and parts in the
            energy field, and the processing of high-precision special alloy in
            the manufacturing of medical equipment.
          </p>

          <p>
            The equipment belongs to directional energy deposition process,
            which uses fiber laser to heat melt metal powder, metal 3D printing
            nozzle to apply molten material layer by layer, and each molten
            material solidifies with the growth of the required shape. This
            process can be used to repair worn parts, such as aviation turbine
            blades. The original design method of metal parts has been
            completely changed to make the products, components and tools
            lighter, realize more functions and reduce the number of assembly
            parts. Integrated high-precision metal manufacturing solution
            integrates software, direct metal printing technology, certified
            materials and expert application support. It can save time, increase
            efficiency, save cost and manufacture lightweight components.
          </p>

          <p>
            Our 3D printers produce plastic conceptual models, high-precision
            and functional prototypes, master molds, and true end use components
            to optimize your design, simplify workflow, and bring innovative
            products to market faster. Direct metal printing (DMP) is made of
            various alloy materials, which can't be realized by traditional
            reduced material manufacturing technology.
          </p>
        </div>
        <!-- 4 -->
        <div v-if="catSelected === 4" class="content">
          <p>
            Need to quickly test out the market with low-volume parts? Or want
            to create large quantities of production parts? Then you can’t go
            wrong with our injection molding services. At 3ERP, we produce
            high-quality prototype moldings from aluminum molds with quick
            turnaround times. Our customers can test out their designs for
            manufacturability and functionality, fast. We also offer plastic
            injection molding for your high-volume production needs.
          </p>

          <p>
            Whether you need rapid tooling, mass production mold making or
            end-use plastic molding with tight tolerances, our team of
            experienced specialists can offer a cost-effective solution at each
            stage.
          </p>
          <div class="img_box cat4">
            <div class="left flex">
              <img src="../assets/images/home/detail1.png" alt="" />
            </div>
            <div class="right">
              <p class="title">Our Advantage of Injection Molding</p>
              <p>
                There are huge numbers of injection molding providers. Why
                should you choose us as your injection molding supplier? Here
                are the top 3 reasons:
              </p>

              <p><strong>1. Experienced Engineers</strong></p>
              <p>
                Our molding engineers has rich experience after handling
                thousands of projects, whatever type of parts they come across,
                they can get the right parameters immediately.
              </p>

              <p><strong>2. Advance Facilities</strong></p>
              <p>
                By using imported and the top brand local made injection molding
                machines, we are able to make the most precise moldings as well
                as great aspect.
              </p>

              <p><strong>3. Unlimited Capacities</strong></p>
              <p>
                Asides from our in house facilities, we have built up the strong
                networks with our partners. Full ranges of injection machines
                from 10 tons to 1000 tons are ready for your orders without
                suspension.
              </p>
            </div>
          </div>
        </div>
        <!-- 5 -->
        <div v-if="catSelected === 5" class="content">
          <p>
            provides a variety of precision CNC machining services including
            milling, turning, EDM (electrical discharge machining) and wire EDM,
            and surface grinding. With our precision 3-, 4- and 5-axis CNC
            machining centers, combined with other advanced capabilities and our
            experienced team, we can handle all technical aspects of creating
            your prototypes and parts, so your team can focus on bringing your
            product to market. If you need a precision machining company for
            plastic and metal CNC machining parts, 3ERP is the best place to go.
            Contact us today to get your manufacturing solution and details.
          </p>
          <div class="img_box">
            <div class="left flex">
              <img src="../assets/images/home/detail2.jpg" alt="" />
            </div>
            <div class="right">
              <p class="title">CNC Milling</p>
              <p>
                Compared with CNC turning, CNC milling, especially 5 axis
                milling can be used to create complex 3D shapes or to apply a
                machined surface or features to parts made both plastics and
                metals. The advantage of multi-axis milling machines makes CNC
                milling process versatile, as well as accurate and repeatable,
                for creating many different types of part features of complex
                geometries. Example include holes, curves, slots, angled shapes,
                and channels. Milling is also ideal for making tooling for
                pressure die casting and plastic injection molding.
              </p>
            </div>
          </div>
          <div class="img_box">
            <div class="left flex">
              <img src="../assets/images/home/detail3.png" alt="" />
            </div>
            <div class="right">
              <p class="title">CNC Turning</p>
              <p>
                CNC lathes allow us to get high-speed turning of both plastics
                and metals from bar or block material. The turning process
                allows the production of complex external and internal
                geometries, including generating all kinds of threads. For any
                round shaped components, for example, shafts, worms, spheres,
                CNC turning is a more efficient method compared with CNC
                milling. 3ERP’s turning capability can make prototypes all the
                way through mass production parts.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Header from '../components/Header.vue'
import Footer from '../components/Footer.vue'
export default {
  metaInfo: {
    title: '东莞市乔斯精密机械有限公司',
    meta: [
      {
        name: 'keywords',
        content: '东莞市乔斯精密机械有限公司,乔斯,精密,机械',
      },
      {
        name: 'description', // 设置页面描述
        content: '品质用心、技术创新、恪守信誉、追求完美',
      },
    ],
  },
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      showDetail: false,
      catList: [
        {
          name: 'Wire EDM',
          desc:
            'It uses continuously moving thin metal wire (called electrode wire) as electrode to remove metal and cut the workpiece by pulse spark discharge.',
          img: require('../assets/images/home/about1.png'),
        },
        {
          name: 'Surface finish',
          desc:
            'It is necessary to select high quality steel and apply corresponding surface treatment technology to improve the service life of the die. Die heat treatment and surface treatment are also the key links to determine the material properties of the fina',
          img: require('../assets/images/home/about2.png'),
        },
        {
          name: '3D printing',
          desc:
            'With a full range of services, we are able to combine 3D printing prototype manufacturing with traditional CNC processing and small batch injection molding to meet the needs of almost every design team.Common hybrid manufacturing equipment integrated',
          img: require('../assets/images/home/about3.png'),
        },
        {
          name: 'CNC lathe',
          desc:
            'CNC machine tools include drilling and tapping machine, parts processing center, mold processing center, horizontal processing center, carving and milling machine, high gloss machine, glass engraving machine, sweeping machine, CNC lathe, Longmen mach',
          img: require('../assets/images/home/about4.png'),
        },
        {
          name: '5-axis CNC milling',
          desc:
            'Need to quickly test out the market with low-volume parts? Or want to create large quantities of production parts? Then you can’t go wrong with our injection molding services.At 3ERP, we produce high-quality prototype moldings from aluminum molds wi',
          img: require('../assets/images/home/about5.png'),
        },
        {
          name: 'CNC milling',
          desc:
            'provides a variety ofprecision CNC machiningservices including milling, turning, EDM (electrical discharge machining) and wire EDM, and surface grinding. With our precision 3-, 4- and 5-axis CNC machining centers, combined with other advanced ca',
          img: require('../assets/images/home/about6.jpg'),
        },
      ],
      catSelected: null,
    }
  },
  created() {
    let query = this.$route.query
    if (query.index) {
      this.catSelected = Number(query.index)
    }
    if (query.showDetail=='true') {
      this.showDetail = true
    } else {
      this.showDetail = false
    }
  },
  methods: {
    selectCat(index) {
      if (index === this.catSelected) {
        return
      }
      this.catSelected = index
    },
    toHome() {
      this.$router.push({ path: '/' })
    },
    toService() {
      // this.$router.go({ path: '/service?index=null' })
      this.catSelected = null
      this.showDetail = false
    },
    toCategory() {
      this.showDetail = false
      this.$forceUpdate()
    },
    toDetail(index) {
      this.catSelected = index
      this.showDetail = true
    },
  },
}
</script>
<style scoped>
.nopointer {
  pointer-events: none;
}
.service_box {
  padding: 40px 0;
}
.breadcrumb {
  width: 100%;
  height: 18px;
  display: flex;
  align-items: center;
  margin-bottom: 37px;
}
.breadcrumb .icon {
  width: 14px;
  height: 18px;
}
.breadcrumb span {
  font-size: 14px;
  color: #555;
  padding: 0 12px;
}
.breadcrumb .arrow {
  width: 20px;
  height: 10px;
}
/* category */
.category {
  height: 40px;
}
.category li {
  height: 40px;
  line-height: 40px;
  width: 190px;
  background: #f7f7f7;
  font-size: 14px;
  color: #2a2a2a;
  padding-left: 20px;
}
.category li.active {
  background: rgb(61, 133, 198);
  color: #fff;
}
/* list */
.list {
  height: 786px;
}
.list li {
  margin-top: 20px;
  width: 384px;
  height: 322px;
  border: 1px solid #cccccc;
}
.list li img {
  width: 362px;
  height: 260px;
  background: #cccccc;
  margin: 11px;
}
.list li .name {
  font-size: 18px;
  color: #2a2a2a;
  text-align: center;
}
/* paganation */
.paganation {
  height: 24px;
  width: 100%;
  margin-top: 28px;
}
.paganation .btn {
  height: 24px;
  line-height: 24px;
  border: 1px solid #ccc;
  font-size: 12px;
  color: #605e5e;
  padding: 0 10px;
  margin-left: 5px;
}
.paganation .btn.current {
  background: #2090ff;
  color: #fff;
}
/* detail */
.detail_box {
}
.detail_box .name {
  font-size: 18px;
  color: #333333;
}
.detail_box img {
  width: 420px;
  height: 340px;
  background: #808080;
  margin-top: 22px;
  margin-bottom: 35px;
}
.detail_box .content {
  font-size: 18px;
  color: #333333;
}
.detail_box .content p {
  padding-bottom: 22px;
  line-height: 24px;
}
.detail_box .content .img_box {
  width: 100%;
  border: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
}
.detail_box .content .img_box:nth-child(2) {
  border-top: none;
}
.detail_box .content .img_box .left {
  border-right: 1px solid #ccc;
  /* width: 620px; */
  padding: 5px 10px 10px;
}
.detail_box .content .img_box .left img {
  width: 620px;
  height: 294px;
  background: #fff;
}
.detail_box .content .img_box.cat4 .left img {
  width: 244px;
  height: 273px;
  background: #fff;
  margin: 0;
}
.detail_box .content .img_box .right {
  padding: 20px 12px;
  font-size: 16px;
}
.detail_box .content .img_box .right .title {
  font-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/service.vue